export const data = [
  {
    title: "pyramid.level1.title",
    text: "pyramid.level1.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-1-color.png",
      "/images/pyramid/webp/pyramid-1-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-1-no-color.png",
      "/images/pyramid/webp/pyramid-1-no-color.webp",
    ],
  },
  {
    title: "pyramid.level2.title",
    text: "pyramid.level2.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-2-color.png",
      "/images/pyramid/webp/pyramid-2-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-2-no-color.png",
      "/images/pyramid/webp/pyramid-2-no-color.webp",
    ],
  },
  {
    title: "pyramid.level3.title",
    text: "pyramid.level3.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-3-color.png",
      "/images/pyramid/webp/pyramid-3-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-3-no-color.png",
      "/images/pyramid/webp/pyramid-3-no-color.webp",
    ],
  },
  {
    title: "pyramid.level4.title",
    text: "pyramid.level4.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-4-color.png",
      "/images/pyramid/webp/pyramid-4-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-4-no-color.png",
      "/images/pyramid/webp/pyramid-4-no-color.webp",
    ],
  },
  {
    title: "pyramid.level5.title",
    text: "pyramid.level5.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-5-color.png",
      "/images/pyramid/webp/pyramid-5-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-5-no-color.png",
      "/images/pyramid/webp/pyramid-5-no-color.webp",
    ],
  },
  {
    title: "pyramid.level6.title",
    text: "pyramid.level6.text",
    imgUrlWithColor: [
      "/images/pyramid/png/pyramid-6-color.png",
      "/images/pyramid/webp/pyramid-6-color.webp",
    ],
    imgUrl: [
      "/images/pyramid/png/pyramid-6-no-color.png",
      "/images/pyramid/webp/pyramid-6-no-color.webp",
    ],
  },
];